import Node from "@/models/Node";
import { PacketType } from '@/models/Packet';
import ProjectServer from '@/models/ProjectServer';
import Tag from '@/models/Tag';
import Timeline from '@/models/Timeline';

/** 
 * - packetType should be one of `NodeCreate`, `TagCreate`, or `TimelineCreate`
 * - As packets of that type arrive, this gets the id if `name` matches
 * - `processorFunction` takes a single argument (id)
 */
export const idRetriever = (packetType : PacketType.NodeCreate | PacketType.TagCreate | PacketType.TimelineCreate, name : string, processorFunction : any) =>
{
    let cb = ProjectServer.instance.registerCallback(packetType, (data : any) =>
    {
        if (packetType === PacketType.NodeCreate && data.name.substring(1) === name)
        {
            ProjectServer.instance.removeCallback(packetType, cb);
            processorFunction(data.nodeid);
        }
        else if (packetType === PacketType.TagCreate && data.name === name)
        {
            ProjectServer.instance.removeCallback(packetType, cb);
            processorFunction(data.tagid);
        }
        else if (packetType === PacketType.TimelineCreate && data.name === name)
        {
            ProjectServer.instance.removeCallback(packetType, cb);
            processorFunction(data.timelineid);
        }
    });
}